var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";


import {
  DatePropertyIcon,
  MarkdownPropertyIcon,
  NumericPropertyIcon,
  TextPropertyIcon } from "../../../../Components/CustomIcons";

import { EmbededButton } from "../../../../Components/UI/EmbededButton";

import { Dot } from "./Dot";
import { SuggestedValue } from "./SuggestedValue";

const propertyIcons = {
  text: /*#__PURE__*/_jsx(TextPropertyIcon, { className: "w-4" }),
  date: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4" }),
  numeric: /*#__PURE__*/_jsx(NumericPropertyIcon, { className: "w-4" }),
  markdown: /*#__PURE__*/_jsx(MarkdownPropertyIcon, { className: "w-4" })
};

const extractorColumnHelper = createColumnHelper();
// Helper typed as any because of https://github.com/TanStack/table/issues/4224
const suggestionColumnHelper = createColumnHelper();

const statusColor = (suggestion) => {
  if (!suggestion.suggestedValue || suggestion.suggestedValue === '') {
    return 'red';
  }
  if (suggestion.currentValue === suggestion.suggestedValue) {
    return 'green';
  }
  return 'orange';
};

const getIcon = (color) => {
  switch (color) {
    case 'orange':
    case 'green':
      return /*#__PURE__*/_jsx(CheckCircleIcon, {});
    case 'red':
      return /*#__PURE__*/_jsx(Dot, { color: color });
    default:
      return '';
  }
};

const ExtractorHeader = () => /*#__PURE__*/_jsx(Translate, { className: "whitespace-nowrap" }, void 0, "Extractor Name");
const PropertyHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Property");
const TemplatesHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Template(s)");
const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Document");
const CurrentValueHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Current Value/Suggestion");
const AcceptHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Accept");
const SegmentHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Context");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const PropertyCell = ({ cell }) => {
  const property = cell.getValue();
  return /*#__PURE__*/(
    _jsx("div", { className: "flex gap-2" }, void 0,
    propertyIcons[property], /*#__PURE__*/
    _jsx("p", { className: "text-gray-500 whitespace-nowrap" }, void 0, cell.row.original.propertyLabel)
    ));

};

const CurrentValueCell = ({
  cell,
  allProperties



}) => /*#__PURE__*/
_jsx(SuggestedValue, {
  value: cell.getValue(),
  suggestion: cell.row.original,
  templateProperties: allProperties }
);


const AcceptButton = ({ cell }) => {var _cell$column$columnDe;
  const color = statusColor(cell.row.original);
  const action = (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.action;
  const suggestionHasEntity = Boolean(cell.row.original.entityId);

  return /*#__PURE__*/(
    _jsx("div", { className: "flex items-center justify-center gap-1" }, void 0, /*#__PURE__*/
    _jsx(EmbededButton, {
      icon: getIcon(color),
      color: color,
      disabled: color === 'green' || color === 'red' || !suggestionHasEntity,
      collapsed: color === 'green',
      onClick: () => action && action([cell.row.original]) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Accept")
    )
    ));

};

const TemplatesCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((templateName) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, templateName, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, templateName)
)
)
);


const LinkButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `suggestions/${cell.getValue()}` }, void 0, /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Review")
)
);


const OpenPDFButton = ({ cell }) => {var _cell$column$columnDe2;
  const action = (_cell$column$columnDe2 = cell.column.columnDef.meta) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.action;
  const suggestionHasEntity = Boolean(cell.row.original.entityId);

  return /*#__PURE__*/(
    _jsx(Button, {
      className: "leading-4",
      styling: "outline",
      disabled: !suggestionHasEntity,
      onClick: () => action && action(cell.row.original) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Open PDF")
    ));

};

const TitleCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "text-xs font-normal text-gray-900" }, void 0, cell.getValue());


const SegmentCell = ({
  cell
}) => {
  const segment = cell.getValue();
  if (segment === '') {
    return /*#__PURE__*/(
      _jsx("span", { className: "text-xs font-normal text-orange-600" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "No context")
      ));

  }
  return segment;
};

const extractorsTableColumns = [
extractorColumnHelper.accessor('name', {
  header: ExtractorHeader,
  meta: { headerClassName: 'w-1/6' }
}),
extractorColumnHelper.accessor('propertyType', {
  header: PropertyHeader,
  cell: PropertyCell,
  meta: { headerClassName: 'w-1/6' }
}),
extractorColumnHelper.accessor('namedTemplates', {
  header: TemplatesHeader,
  enableSorting: false,
  cell: TemplatesCell,
  meta: { headerClassName: 'w-4/6' }
}),
extractorColumnHelper.accessor('_id', {
  header: ActionHeader,
  enableSorting: false,
  cell: LinkButton,
  meta: { headerClassName: 'sr-only invisible bg-gray-50' }
})];




const suggestionsTableColumnsBuilder = (
templates,
acceptSuggestions,
openPdfSidepanel) =>
{
  const allProperties = [...(templates[0].commonProperties || []), ...templates[0].properties];

  return [
  suggestionColumnHelper.accessor('entityTitle', {
    header: TitleHeader,
    cell: TitleCell,
    meta: { headerClassName: 'w-3/12' }
  }),
  suggestionColumnHelper.accessor('segment', {
    header: SegmentHeader,
    cell: SegmentCell,
    meta: { headerClassName: 'w-3/12' }
  }),
  suggestionColumnHelper.accessor('currentValue', {
    header: CurrentValueHeader,
    cell: (cell) => /*#__PURE__*/_jsx(CurrentValueCell, { cell: cell, allProperties: allProperties }),
    meta: { headerClassName: 'w-3/12' }
  }),
  suggestionColumnHelper.display({
    id: 'accept-actions',
    header: AcceptHeader,
    cell: AcceptButton,
    meta: {
      action: acceptSuggestions,
      headerClassName: 'w-1/12 text-center',
      contentClassName: 'text-center'
    }
  }),
  suggestionColumnHelper.display({
    id: 'open-pdf-actions',
    header: ActionHeader,
    cell: OpenPDFButton,
    meta: {
      headerClassName: 'sr-only invisible bg-gray-50',
      contentClassName: 'text-center',
      action: openPdfSidepanel
    }
  })];

};


export { extractorsTableColumns, suggestionsTableColumnsBuilder };